<template>
  <div class="big">
    <div class="page_title flex_between">
      <span>医生义诊活动（患）详情</span>
      <el-button type="primary"
                 style="width: 92px"
                 @click="back"
                 size="medium">返回</el-button>
    </div>
    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <div class="smart-examine">
          <el-tabs v-model="activeName">
            <el-tab-pane label="基础信息"
                         name="1"></el-tab-pane>
            <el-tab-pane label="医生维护"
                         name="2"
                         :disabled="module_id_array[0]?!module_id_array.includes('1188'):false"></el-tab-pane>
          </el-tabs>
          <component :is="currentComponent" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import basicInfo from './basicInfo/index.vue';
import doctorMaintain from './doctorMaintain/index.vue';
export default {
  components: {
    basicInfo,
    doctorMaintain
  },
  data() {
    return {
      activeName: '1'
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    currentComponent() {
      switch (this.activeName) {
        case '1':
          return basicInfo;
        case '2':
          return doctorMaintain;
        default:
          return basicInfo;
      }
    }
  },
  created() {},
  methods: {
    back() {
      history.back();
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  padding: 20px;
  text-align: left;
}
</style>